const NotImplemented = () => 'Per questa tipologia di esercizio non è possibile utilizzare il visualizzatore.';

export default NotImplemented;
